import { queryOptions, useQuery } from '@tanstack/react-query';

import { primaryPrivateV2Api } from '@/lib/api-clients/rest-client';
import { ErrorCode } from '@/types';

import { StatusResponse } from './types';
import { useAffiliateAuth } from './use-affiliate-auth';

const PATHNAME = '/v3/affiliate/status';

export const getAffiliateStatusQueryKey = (
  address: string | undefined | null,
) => [PATHNAME, address];

export const getAffiliateStatusQueryOptions = (
  address: string | undefined | null,
) =>
  queryOptions<StatusResponse, ErrorCode>({
    staleTime: 15_000,
    queryKey: getAffiliateStatusQueryKey(address),
    queryFn: () => primaryPrivateV2Api.get<StatusResponse>(PATHNAME),
  });

export default function useAffiliateStatus() {
  const { address, isEnabled } = useAffiliateAuth();

  return useQuery({
    enabled: isEnabled,
    ...getAffiliateStatusQueryOptions(address),
  });
}
